import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import DiscoverMoreLinkPrimePageDP from "../components/acquisition/DiscoverMoreLink/versions/DiscoverMoreLinkPrimePageDP";
import withPrimeContext from "../withPrimeContext";

export default withPrimeContext(
  withErrorBoundary(DiscoverMoreLinkPrimePageDP, {
    name: "DiscoverMoreLinkPrimePageDP",
  }),
);
